module.exports = __webpack_public_path__ + "img/side_bg.92f1f17c.png";